// Opsi warna chrome canvas-gauges ikut tema; needle/highlight (makna) gak disentuh.
import { CHART_TEXT_COLOR, CHART_TEXT_MUTED_COLOR, CHART_BORDER_COLOR } from './chartTheme.js';

function mode(theme) {
  return theme === 'dark' ? 'dark' : 'light';
}

export function gaugeThemeColors(theme) {
  const gaugeMode = mode(theme);
  const text = CHART_TEXT_COLOR[gaugeMode];
  const muted = CHART_TEXT_MUTED_COLOR[gaugeMode];
  const border = CHART_BORDER_COLOR[gaugeMode];

  return {
    colorPlate: 'transparent',
    colorMajorTicks: text,
    colorMinorTicks: muted,
    colorNumbers: text,
    colorTitle: text,
    colorUnits: muted,
    colorBorderOuter: border,
    colorBorderOuterEnd: border,
    colorNeedleCircleOuter: border,
    colorNeedleCircleOuterEnd: border,
    colorValueBoxRect: border,
    colorValueBoxRectEnd: border,
    colorValueBoxBackground: 'transparent',
    colorValueText: text,
  };
}

export default gaugeThemeColors;
